import React from 'react';
import { THEME_CONFIG } from '../constants';

const Legal: React.FC = () => {
  return (
    <section id="legal" className="py-12 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white mb-4">Aviso Legal</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Última actualización: {new Date().toLocaleDateString('es-ES', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        <div className="prose dark:prose-invert max-w-none text-gray-700 dark:text-gray-300 space-y-8">
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-xl">
            <h2 className="text-2xl font-bold text-secondary dark:text-white mb-4">1. Identificación del Titular</h2>
            <p className="mb-4">
              <strong>Denominación Social:</strong> {THEME_CONFIG.clinicName} S.L.<br />
              <strong>Domicilio Social:</strong> [Dirección completa del centro]<br />
              <strong>CIF/NIF:</strong> [Número de identificación fiscal]<br />
              <strong>Inscrita en el Registro Mercantil de [Ciudad], Tomo [X], Folio [X], Hoja [X], Inscripción [X]</strong>
            </p>
            <p>
              <strong>Datos de contacto:</strong><br />
              Teléfono: [Número de teléfono]<br />
              Email: [Email de contacto]<br />
              Web: [URL del sitio web]
            </p>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-secondary dark:text-white">2. Condiciones de Uso</h2>
            
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">2.1 Acceso y Navegación</h3>
              <p>
                El acceso y uso de este sitio web le otorga la condición de USUARIO y supone la aceptación plena y sin reservas, desde dicho acceso y/o uso, de las condiciones generales de uso que se recogen en este documento.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">2.2 Uso del Sitio Web</h3>
              <p>
                El usuario se compromete a hacer un uso adecuado y lícito del sitio web y de los contenidos y servicios, de conformidad con la legislación aplicable, el presente Aviso Legal, la moral y buenas costumbres generalmente aceptadas y el orden público.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-secondary dark:text-white">3. Propiedad Intelectual e Industrial</h3>
              <p>
                {THEME_CONFIG.clinicName} es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo, imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.), titularidad de {THEME_CONFIG.clinicName} o bien de sus licenciantes.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-secondary dark:text-white">4. Protección de Datos</h3>
              <p>
                De conformidad con lo dispuesto en la normativa vigente en Protección de Datos de Carácter Personal, le informamos que los datos personales que nos facilite a través del formulario de contacto o cualquier otro medio serán tratados por {THEME_CONFIG.clinicName} con la finalidad de gestionar su solicitud y prestarle los servicios solicitados.
              </p>
              <p>
                Puede ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad, así como retirar su consentimiento en cualquier momento, dirigiéndose por escrito a nuestra dirección postal o electrónica, acompañando copia de su DNI o documento identificativo equivalente.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-secondary dark:text-white">5. Legislación Aplicable y Jurisdicción</h3>
              <p>
                Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales de [Ciudad], España.
              </p>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/30 p-6 rounded-xl border-l-4 border-primary">
              <h3 className="text-xl font-semibold text-primary dark:text-primary-300 mb-2">Información Adicional</h3>
              <p className="mb-0">
                Para cualquier consulta sobre este aviso legal, puede contactar con nosotros a través de [email de contacto] o en la dirección [dirección física].
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legal;